/**
 * @file        src/lib/format.js
 * @description INR + date formatters. One source of truth.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 *   - 2026-07-30 Claude — Added inrExact for the Cash Balance card, where the
 *                          paise matter and rounding to "₹0" would read as
 *                          "no data" on a genuinely empty wallet.
 */
const inrFmt = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

export const inr = (n) => `₹${inrFmt.format(Math.round(Number(n) || 0))}`;

// Always two decimals, en-IN grouping (₹0.00 · ₹250.50 · ₹12,450.75 · ₹1,25,000.00).
// Used where the exact figure is the point — a supplier wallet balance — as
// opposed to inr/inrCompact, which round for at-a-glance reporting.
const inrExactFmt = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const inrExact = (n) => `₹${inrExactFmt.format(Number(n) || 0)}`;

export function inrCompact(value) {
  const n = Number(value || 0);
  if (n >= 1e7) return `₹${(n / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹${(n / 1e5).toFixed(2)} L`;
  return inr(n);
}

const fullDate = new Intl.DateTimeFormat('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
const fullDateTime = new Intl.DateTimeFormat('en-IN', {
  day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

export function formatDate(v) { return v ? fullDate.format(new Date(v)) : '—'; }
export function formatDateTime(v) { return v ? fullDateTime.format(new Date(v)) : '—'; }
